// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"61":"a6e840e8","242":"2ea077ca","372":"113ec81d","628":"ca567f30","844":"17879841"}[chunkId] + ".js";
};